import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import WorkflowmodelSchema from 'sitemodel/schema/components/WorkflowmodelSchema'

export type WorkflowmodelContainerProps = schemaToReactType<
  typeof WorkflowmodelSchema
>

export const WorkflowmodelContainerTypeGuard =
  schemaToTypeGuard(WorkflowmodelSchema)
